// tslint:disable
import { callStatic, TopCommentsResponse } from 'services/api-service'

/**
 * Top comments
 *
 * @method
 * @name ApiService#topComments
 * @param {string} skus - Comma separated list of skus
 * @param {integer} minCharCount -
 * @param {integer} minWordCount -
 * @param {string} tags - Comma separated list of tags
 * @param {boolean} includeSyndicated -
 */
function topComments(parameters: {
  skus: string
  minCharCount: number
  minWordCount: number
  tags: string
  includeSyndicated: boolean
}): Promise<TopCommentsResponse> {
  return callStatic<TopCommentsResponse>(
    '/sitedata/{siteKey}/topcomment/{skus}/{locale}/{minCharCount}/{minWordCount}/{tags}/{includeSyndicated}',
    parameters,
    ['skus', 'minCharCount', 'minWordCount', 'tags', 'includeSyndicated']
  )
}

export default { topComments }
